import React from "react";
import Icon from "../../../components/ui/Icon";
import { formatDateTime } from "../../../helpers/order.helper";
import { formatBRL } from "../../../helpers/currency.helper";
import { OrderSummary } from "../types";
import StatusBadge from "./StatusBadge";
import { Row, Info, Title, Sub, Chevron } from "./OrderListItem.styles";

interface OrderListItemProps {
  order: OrderSummary;
  onClick: () => void;
}

export default function OrderListItem({ order, onClick }: OrderListItemProps) {
  return (
    <Row type="button" onClick={onClick}>
      <Info>
        <Title>
          Pedido #{order.document} — {formatBRL(order.total)}
        </Title>
        <Sub>Criado em: {formatDateTime(order.createdAt)}</Sub>
      </Info>
      <StatusBadge status={order.status} />
      <Chevron>
        <Icon name="chevron" size={16} />
      </Chevron>
    </Row>
  );
}
